import { regex } from './common'
export default regex('mobilePhone', /^[0-9]{10}$/)